import { render, staticRenderFns } from "./VkFieldSet.vue?vue&type=template&id=b04ca726&"
import script from "./VkFieldSet.vue?vue&type=script&lang=ts&"
export * from "./VkFieldSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports